import axios from '@/axios.js'
import router from '@/router.js'
import config from '@/config.js'

export default {
    settings({ commit, state }, response) {
        commit('SETTINGS', response);
    },
    resetState({ commit }) {
        commit('RESET_STATE');
    },
    updatePassword({ state, commit, dispatch })  {
        var data = state.steps[0].payload;
        axios.post('/account/password', {
            password: data.password,
            repeat_password: data.password_confirmation
        })
        .then(function (response) {
            if(response.status == 200)
                commit('UPDATE_PASSWORD');
            dispatch('notification/notification', response, {root: true });
            state.steps[0].isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.steps[0].isLoading = false;
        });
    },
    fetchCountries({ commit, dispatch }, data) {
        axios.get(`/global/countries?defaultCountry=${data.defaultCountry}`)
        .then(function (response) {
            if (response.status === 200)
                commit('COUNTRIES', response.data);
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
        });
    },
    async updateBillingInfo({ commit, dispatch }, data) {
        try {
            data.adress = data.address;
            const request = await axios.post('/client/billing-details', data);

            dispatch('notification/notification', {
                data: {
                    message: 'Date actualizate cu succes!'
                },
                status: 200
            }, {root: true });

            if (request.status === 200) {
                localStorage.setItem('address', 'true');
                dispatch('user/update', request.data, { root: true });
            }
        } catch (error) {
            dispatch('notification/notification', null, {root: true})
        }
    },
    updateImage({ state, commit, dispatch }, image)  {
        var data = state.steps[2].payload;

        const formData = new FormData();
        formData.append('image', image);

        axios.post('/specialist/account/profile-picture', formData, {
            headers: {
               'Content-Type':'multipart/form-data'
            }
        })
        .then(function (response) {
            if(response.status == 200) {
                commit('UPDATE_IMAGE', response.data);
                dispatch('user/update', response.data, {root: true })
            }
            dispatch('notification/notification', response, {root: true });
            state.steps[2].isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.steps[2].isLoading = false;
        });
    },
    updateVideo({ state, commit, dispatch }, video)  {
        var data = state.steps[2].payload;

        const formData = new FormData();
        formData.append('video', video);

        axios.post('/specialist/account/profile-video', formData, {
            headers: {
               'Content-Type':'multipart/form-data'
            }
        })
        .then(function (response) {
            if(response.status == 200) {
                commit('UPDATE_VIDEO', response.data);
                dispatch('user/update', response.data, {root: true })
            }
            dispatch('notification/notification', response, {root: true });
            state.steps[2].isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.steps[2].isLoading = false;
        });
    },
    updateDetails({ state, commit, dispatch }, type)  {
        var data = {};
        data.type = type;
        switch(data.type) {
            case 'profile': {
                data = state.steps[1].payload;
                break;
            }
            case 'titleAndBasePrice': {
                data = state.steps[3].payload;
                break;
            }
        }
        axios.post('/account/details', data)
        .then(function (response) {
            if(response.status == 200) {
                commit('UPDATE_DETAILS', data);
                dispatch('user/update', data, {root: true })
            }
            dispatch('notification/notification', response, {root: true });
            state.steps[1].isLoading = false;
            state.steps[3].isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.steps[1].isLoading = false;
            state.steps[3].isLoading = false;
        });
    },
    updateDescription({ state, commit, dispatch })  {

        var defaults = ['about', 'experience', 'education'];
        var payload = state.steps[4].payload;
        var data = {
            about: payload.descriptions[0].value,
            experience: payload.descriptions[1].value,
            education: payload.descriptions[2].value,
            default: defaults[payload.selectedIndex]
        }

        axios.post('/specialist/account/description-fields', data)
        .then(function (response) {
            if(response.status == 200) {
                dispatch('user/update', data, {root: true })
            }
            dispatch('notification/notification', response, {root: true });
            state.steps[4].isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.steps[4].isLoading = false;
        });
    },
    updateTimetable ({ state, commit, dispatch })  {
        let payload = state.steps[5].payload;
        var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

        days.forEach((day, i) => {
            payload.timetable[day].forEach((interval, i) => {
                var time = interval.start_time;
                interval.start_time = time['HH']+':'+time['mm']
                time = interval.end_time;
                interval.end_time = time['HH']+':'+time['mm']
            });
        });
        axios.post('/specialist/account/timetable', {
            available: payload.appointments,
            overtime: payload.anytimeServices,
            timetable: payload.timetable
        })
        .then(function (response) {
            if(response.status == 200) {
                
                commit('UPDATE_TIMETABLE', response);
                dispatch('user/user', response, {root: true })
            }
            dispatch('notification/notification', response, {root: true });
            state.steps[5].isLoading = false;
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true});
            state.steps[5].isLoading = false;
        });
    },
    fetchInvite({ commit, dispatch }) {
        var inviteToken = router.currentRoute.params.inviteToken;
        // Redirect user to client url if the invite token is inexistent
        if(!inviteToken)
            window.location.replace(config.CLIENT_HOST);

        axios.post('/account/invite/auth', {
            secret: inviteToken
        })
        .then(function (response) {
            const specialist = response.data.specialist;
            if(specialist && specialist.invite_step <= 6) {
                commit('FETCH_INVITE', response);
                dispatch('user/user', response, {root: true })
            } else {
                const token = localStorage.getItem('token');
                if(token)
                    router.push(`/specialist/stats`);
                else
                    router.push(`/specialist/login`);
            }
        })
        .catch(function (error) {
            // Redirect user to client url if the invite token is invalid
            window.location.replace(config.CLIENT_HOST);
            dispatch('notification/notification', error.response, {root: true})
        });
    },
}
